<script>
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  name: "form-add-peserta",
  props: ["idPembelajaran"],
	emits: ["closeModal", "refreshTable"],

  data() {
    return {
      id: this.idPembelajaran,

      file_excel: null,
			errorMessage: null,

			showModal: {
				errorMessage: false,
			},
    };
  },

  mounted() {
    // alert("Data " + this.id);
  },

  methods: {
    downloadFile() {
      const link = document.createElement("a");
      link.href = "/template_excel/template_tahapan_diklat.xlsx";
      link.download = "/template_excel/template_tahapan_diklat.xlsx";
      link.click();
    },

    uploadFile() {
      let self = this;
      if ($("#importexcel")[0].files[0]) {
        if ($("#importexcel")[0].files[0].size < 2242880) {
          $("#uploadLoadingExcel").html(
            '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
          );
          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#importexcel")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            console.log(response.data.data.path_file);
            var path_file = response.data.data.path_file;
            urlres += path_file;
            $("#uploadLoadingExcel").html(
              '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                urlres +
                '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
            );
            self.file_excel = path_file;
          });
        }
      }
    },

    importData() {
      let self = this;
      // self.showModal = false;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/kode-pembelajaran/import-tahapan-diklat",
        data: {
          path_file: self.file_excel,
          id: self.id,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then(function (response) {
					if(response.data.meta.code == 200){
						self.file_excel = null,
						$("#uploadLoadingExcel").empty();
						$('#importexcel').val('');
						
						self.$emit("closeModal");
						self.$emit("refreshTable");
						
						self.showModal.errorMessage = true;
						self.errorMessage = response.data.data.data_error;
						

						Swal.fire({
							icon: "success",
							title: "Berhasil",
							text: "Import Data Berhasil",
							timer: 2000,
							timerProgressBar: true,
							showCancelButton: false,
							showConfirmButton: false,
						}).then((result) => {
							if (result.dismiss === Swal.DismissReason.timer) {
								Swal.close();
								// self.showModalImport = false;
								// self.getDataTablePeserta();

                if(self.errorMessage != ''){
                  var error = self.errorMessage.join("\n");
                  alert(error);
                }

								self.errorMessage = null;
							}
						});
					}
        })
        .catch(function (error) {
          console.clear();
					console.log(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            html: 'Something went wrong ! + <br>' + error.data.message,
            showConfirmButton: true,
            showCancelButton: false,
          })
        });
    },
  },
};
</script>
<template>
  <div class="col-12">
    <div class="mb-3">
      <button class="btn btn-sm btn-success" @click="downloadFile">
        <i class="dripicons-article"> </i>
        Download Template
      </button>
    </div>
  </div>
  <b-form class="p-2" @submit.prevent="importData">
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label for="Kode">Import File Excel</label>
          <input
            class="form-control"
            type="file"
            id="importexcel"
            @change="uploadFile"
          />
        </div>
        <div
          class="respond-input-file float-left"
          id="uploadLoadingExcel"
        ></div>
      </div>
    </div>
    <div class="text-end pt-3 mt-2">
      <b-button type="submit" variant="success" class="ms-1">
        <i class="fas fa-save"></i>
        &nbsp;
        <b>Save</b>
      </b-button>
    </div>
  </b-form>

	<b-modal v-model="showModal.errorMessage" title="Import Tahapan Diklat" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
    <!-- {{ $errorMessage }} -->
		<h1>Testing</h1>
  </b-modal>
</template>
